<!--
  SectionHeading Component
  Card heading: icon + title, optional description via default slot (Spec 105 E4).
  tone="danger" colors the whole heading (icon inherits) for destructive sections.
-->
<script lang="ts">
  import type { ComponentType } from 'svelte';

  export let icon: ComponentType;
  export let title: string;
  export let tone: 'default' | 'danger' = 'default';
</script>

<h2
  data-testid="section-heading"
  class="flex items-center gap-2 text-sm font-semibold mb-1 {tone === 'danger'
    ? 'text-error'
    : 'text-text'}"
>
  <svelte:component
    this={icon}
    class="w-4 h-4 {tone === 'danger' ? '' : 'text-accent'}"
    strokeWidth={1.5}
  />
  {title}
</h2>
<slot />
